import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { CUISINE_TYPES_QUERY } from '../graphql/queries'
import { FETCH_CUISINE_TYPES } from '../redux/action-types'
import { cleanupFetchCuisineTypes } from '../redux/actions'

const useCuisineTypesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchCuisineTypes)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.cuisineTypes.cuisineTypes,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        CUISINE_TYPES_QUERY,
        {},
        dispatch,
        FETCH_CUISINE_TYPES,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useCuisineTypesQuery
